export const iraOptions = [
  { label: 'None', value: 'none' },
  { label: 'Contributions into a Traditional IRA in tax year? (Form 5498)', value: 'traditionalIraTaxYear' },
  { label: 'Contributions into a Roth IRA in tax year? (Form 5498)', value: 'rothIraTaxYear' },
];

export const educationalLoansOptions = [
  { label: 'None', value: 'none' },
  { label: 'Interest in Student/Education Loans in the US during tax year? (Form 1098-E)', value: 'educationalLoansInTaxYear' },
  { label: 'Education Expenses for Higher Education? Form (Form 1098-T)', value: 'expensesForHigherEducation' },
];

export const hsafsaOptions = [
  { label: 'None', value: 'none' },
  { label: 'Invested into a HSA / FSA during 2023? Form 5498-A', value: 'investedInHsaFsa' },
];